import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Card } from '../domain/card';
import { CardActionBase } from '../domain/card-actions/card-action.base';

@Component({
  selector: 'crds-questions',
  template: `
    <div *ngFor="let question of questions">
      <div [ngSwitch]="question.controlType" [formGroup]="form" class="form-group">
        <crds-question-postcode *ngSwitchCase="'PostcodeQuestion'" [question]="question" [form]="form">
        </crds-question-postcode>
        <crds-question-google-maps-marker *ngSwitchCase="'MapsMarkerQuestion'" [question]="question" [form]="form">
        </crds-question-google-maps-marker>
        <crds-question-dropdown *ngSwitchCase="'DropdownQuestion'" [question]="question" [form]="form">
        </crds-question-dropdown>
        <crds-question-multi-dropdown-value *ngSwitchCase="'MultiDropdownQuestion'" [question]="question" [form]="form">
        </crds-question-multi-dropdown-value>
        <crds-address-list-question-dropdown
          *ngSwitchCase="'AddressDropdownQuestion'"
          [question]="question"
          [form]="form"
        >
        </crds-address-list-question-dropdown>
        <crds-question-general *ngSwitchCase="'GeneralText'" [question]="question" [form]="form">
        </crds-question-general>
        <crds-question-image-upload *ngSwitchCase="'ImageUploadQuestion'" [question]="question" [form]="form">
        </crds-question-image-upload>
        <crds-question-multi-image-upload
          *ngSwitchCase="'MultiImageUploadQuestion'"
          [question]="question"
          [form]="form"
        >
        </crds-question-multi-image-upload>
        <crds-question-ocr-image-upload *ngSwitchCase="'OcrImageUploadQuestion'" [question]="question" [form]="form">
        </crds-question-ocr-image-upload>
        <crds-question-signature *ngSwitchCase="'SignatureQuestion'" [question]="question" [form]="form">
        </crds-question-signature>
        <crds-question-textbox *ngSwitchCase="'TextboxQuestion'" [question]="question" [form]="form">
        </crds-question-textbox>
        <crds-question-textarea *ngSwitchCase="'TextareaQuestion'" [question]="question" [form]="form">
        </crds-question-textarea>
        <crds-question-toggle *ngSwitchCase="'ToggleQuestion'" [question]="question" [form]="form">
        </crds-question-toggle>
        <crds-question-button-group *ngSwitchCase="'ButtonGroupQuestion'" [question]="question" [form]="form">
        </crds-question-button-group>
        <crds-freeform-address-question *ngSwitchCase="'FreeformGoogleAddress'" [question]="question" [form]="form">
        </crds-freeform-address-question>
        <crds-question-doc-viewer
          *ngSwitchCase="'DocumentViewerQuestion'"
          [question]="question"
          [form]="form"
        ></crds-question-doc-viewer>
      </div>
    </div>
  `,
  styleUrls: ['../sass/main.scss'],
  encapsulation: ViewEncapsulation.None
})
export class QuestionsComponent implements OnInit {
  @Input() card: Card<CardActionBase>;
  @Input() form: FormGroup;

  questions: any;

  ngOnInit() {
    this.questions = Object.assign([], this.card.questions);
  }
}
